import classNames from "classnames";

import { useSelector } from "@/redux/hooks";
import { getFormattedLocation } from "@/redux/selectors/location";

import ProductsAd from "../ProductsAd/ProductsAd";

const AD_UNITS = [
  "product_slot_1",
  "product_slot_2",
  "product_slot_3",
  "product_slot_4",
];

export const FeaturedProducts = ({
  categoryName,
  className,
  innerClassname = "min-h-[266px]",
  shopSubcategoryTestEnabled,
  titleOverride,
}: {
  categoryName?: string;
  className?: string;
  innerClassname?: string;
  shopSubcategoryTestEnabled?: boolean;
  titleOverride?: string;
}) => {
  const leaflyLocation = useSelector(getFormattedLocation);

  return (
    <section className={className} data-testid="featured-product-ads">
      {shopSubcategoryTestEnabled ? (
        <h2 className="mb-sm md:hidden">Featured products</h2>
      ) : (
        <h2 className="mb-sm">
          {titleOverride ||
            `Featured ${categoryName || "Cannabis Products"} in ${leaflyLocation || "Seattle, WA"}`}
        </h2>
      )}
      <div className="row">
        {AD_UNITS.map((unit, i) => (
          <div
            className="mb-lg lg:mb-none col-1/2 lg:col-1/4"
            key={`featured-product-${i}`}
            data-testid={`featured-product-${i}`}
          >
            <div
              className={classNames(
                "shadow-low rounded overflow-hidden flex items-center",
                innerClassname,
              )}
            >
              <ProductsAd unit={unit} className="w-full" />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
